import * as actions from '../actions/actionTypes';

const initialState = {
    bankOfHours: [],
};

const fetchBankOfHoursSucces = (state, action) => ({ ...state, bankOfHours: action.bankOfHours });


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.FETCH_BANK_OF_HOURS_SUCCESS:
      return fetchBankOfHoursSucces(state, action);
    default:
      return state;
  }
};

export default reducer;
